import $ from 'jquery'
import messageResource from '../../../messageResource'
import {DateFormat} from '../../../date_format'
import {ChartType} from '../../constants'
import {PaperOrientation, PaperSize} from '../../../pdf/constants'
import PDFImageCache from '../../../pdf/PDFImageCache'

/*
Its file contains parts for construct pdf files
All sizes are specific for pdfmake .For convert it to mm need divide by coeff = 2.835
 */
export const ChartPDFTemplateConstructors = {

    imageWithSizes: function(imageSizes, imageBase64) {
        return {
            height: imageSizes.h,
            width: imageSizes.w,
            image: imageBase64
        };
    },

    fakeImage: function() {
        return '';
    },

    logoPicture: function( logoPictureBase64, dimensions){
        return {
            width: dimensions.w,
            height: dimensions.h,
            marginTop: dimensions.mT,
            marginLeft: dimensions.mL,
            rowSpan: 3,
            image: logoPictureBase64
        };
    },

    filterView: function(filterViewParams, firstRowLeftText, secondRowText){
        var margins = filterViewParams.margins;
        var marginsImage = filterViewParams.imageMargins;
        var firstRowMargins = filterViewParams.firstRowMargins;
        var secondRowMargins = filterViewParams.secondRowMargins;

        return {
            style: 'filterView',
            layout: 'thinBordersNoPaddingsForFilterView',
            marginTop: margins.top,
            fontSize: filterViewParams.fontSize,

            table: {
                widths: filterViewParams.widths,

                body: [
                    [
                        {
                            marginLeft: marginsImage.left,
                            marginTop: marginsImage.top,
                            rowSpan: 2,
                            width: filterViewParams.imageWidth,
                            margin: [12, firstRowMargins.top, 6, firstRowMargins.bottom],
                            // filter.png image in base64 format
                            image: PDFImageCache.getImage('filterIcon').image
                        },
                        {
                            marginTop: firstRowMargins.top,
                            marginBottom: firstRowMargins.bottom,
                            noWrap: true,
                            text: firstRowLeftText
                        }
                    ],
                    [
                        '',
                        {marginRight: 12, marginBottom: secondRowMargins.bottom, noWrap: true, text: secondRowText}
                    ]
                ]
            }
        };
    },

    filterViewWithThreeRows(filterViewParams, firstRowLeftText, secondRowText, thirdRowText){
        const margins = filterViewParams.margins
        const marginsImage = filterViewParams.imageMargins
        const firstRowMargins = filterViewParams.firstRowMargins
        const secondRowMargins = filterViewParams.secondRowMargins
        const thirdRowMargins = filterViewParams.thirdRowMargins

        return {
            style: 'filterView',
            layout: 'thinBordersNoPaddingsForFilterView',
            marginTop: margins.top,
            fontSize: filterViewParams.fontSize,

            table: {
                widths: filterViewParams.widths,

                body: [
                    [
                        {
                            marginLeft: marginsImage.left,
                            marginTop: marginsImage.top,
                            width: filterViewParams.imageWidth,
                            image: PDFImageCache.getImage('filterIcon').image,
                        },
                        {
                            marginTop: firstRowMargins.top,
                            marginBottom: firstRowMargins.bottom,
                            noWrap: true,
                            text: firstRowLeftText
                        }
                    ],
                    [
                        {text: ''},
                        {
                            marginTop: secondRowMargins.top,
                            marginBottom: secondRowMargins.bottom,
                            noWrap: true,
                            text: secondRowText
                        }
                    ],
                    [
                        {text: ''},
                        {
                            marginRight: 12,
                            marginTop: thirdRowMargins.top,
                            marginBottom: thirdRowMargins.bottom,
                            noWrap: true,
                            text: thirdRowText
                        }
                    ],
                ]
            }
        };
    },

    chartInformation: function( chartInfoParams, logoElement, reportName, dateDescription, grandTotalDescription, grandTotalValue){
        var columnWidths = chartInfoParams.widths;
        var splitterLen = chartInfoParams.splitterLen;
        return {
            widths: columnWidths,
            body: [
                [
                    logoElement,
                    [
                        { style: 'chartNameLabel', text: reportName },
                        { style: 'dateRangeLabel', text: dateDescription }
                    ]
                ],
                [
                    '',
                    {
                        style: 'headerSeparator',
                        canvas: [
                            {
                                type: 'line',
                                x1: 0, x2: splitterLen,
                                y1: 0, y2:0,
                                lineWidth: 0.9,
                                dash: {length: 2},
                                lineColor: '#b7b7b7'
                            }
                        ]
                    }
                ],
                [
                    '',
                    {
                        style: 'grandTotalLabel',
                        text:
                                [
                                    { text: grandTotalDescription.label},
                                    ' ',
                                    { style: 'grandValue', text: grandTotalValue },
                                    ' ',
                                    { style: 'grandPostfix', text: grandTotalDescription.postfix}
                                ]
                    }
                ]
            ]
        };
    },

    colorValuePercentRow: function(color, categoryName, value, percents, styles, isSecond) {
        const rectDimensions = styles.colorRectangleDimensions
        const fillColor = isSecond ? '#eeeeee' : ''
        return [
            {
                width: 0,
                canvas: [
                    {
                        type: 'rect',
                        x: rectDimensions.x,
                        y: rectDimensions.y,
                        w: rectDimensions.w,
                        h: rectDimensions.h,
                        color: color,
                        strokeOpacity: 0.001 // hide rect line that visible when color not specified
                    }
                ]
            },
            {width: "*", noWrap: true, marginLeft: rectDimensions.paddingLeft, style: styles.dataNameStyle, text: categoryName, fillColor: fillColor},
            {width: "auto", noWrap: true, style: styles.dataValueWithPercentStyle, text: value, fillColor: fillColor},
            {width: 40, style: styles.dataValueStyle, text: percents, fillColor: fillColor}
        ]
    },

    colorValueRow: function(color, categoryName, value, styles, isSecond) {
        const rectDimensions = styles.colorRectangleDimensions
        const fillColor = isSecond ? '#eeeeee' : ''
        return [
            {
                width: 0,
                canvas: [
                    {
                        type: 'rect',
                        x: rectDimensions.x,
                        y: rectDimensions.y,
                        w: rectDimensions.w,
                        h: rectDimensions.h,
                        color: color,
                        strokeOpacity: 0.001 // hide rect line that visible when color not specified
                    }
                ]
            },
            {width: "*", noWrap: true, marginLeft: rectDimensions.paddingLeft, style: styles.dataNameStyle, text: categoryName, fillColor: fillColor},
            {width: "auto", noWrap: true, style: styles.dataValueStyle, text: value, fillColor: fillColor}
        ]
    },

    valueRow: function(categoryName, value, styles, isSecond) {
        var fillColor = isSecond ? '#eeeeee' : ''
        return [
            {width: "*", noWrap: true, style: styles.dataNameStyle, text: categoryName, fillColor: fillColor},
            {width: "auto", noWrap: true, style: styles.dataValueStyle, text: value, fillColor: fillColor}
        ]
    },

    stackedValueRow: function(
        categoryName, categoryWidths,
        totalValue, totalWidths,
        values, valuesWidths,
        styles,
        isSecond,
        isHeader
    ) {
        const fillColor = isSecond ? '#eeeeee' : ''
        const fontSize = isHeader ? 6 : undefined
        const fontColor = isHeader ? '#636363' : ''
        const row = [
            {
                noWrap: true,
                style: styles.dataNameStyle,
                text: categoryName,
                fillColor: fillColor,
                fontSize: fontSize,
                color: fontColor,
                width: categoryWidths
            },
            {
                noWrap: true,
                style: styles.dataValueStyle,
                text: totalValue,
                fillColor: fillColor,
                fontSize: fontSize,
                color: fontColor,
                width: totalWidths
            }
        ]

        for (let i = 0; i < values.length; i++) {
            row.push({
                noWrap: true,
                style: styles.dataValueStyle,
                text: values[i].value,
                fillColor: fillColor,
                fontSize: fontSize,
                color: fontColor,
                width: valuesWidths[i]
            })
        }

        return row
    },

    valuePercentRow: function(categoryName, value, percents, styles, isSecond) {
        const fillColor = isSecond ? '#eeeeee' : ''
        return [
            {width: "*", noWrap: true, style: styles.dataNameStyle, text: categoryName, fillColor: fillColor},
            {width: "auto", noWrap: true, style: styles.dataValueWithPercentStyle, text: value, fillColor: fillColor},
            {width: 40, style: styles.dataValueStyle, text: percents, fillColor: fillColor}

        ]
    },
}

export const ChartPDFPlaceholderConstructors = {

    headerLandscape: function( chartInformation, filterView ){
        return {
            columns: [
                {
                    width:'67%',
                    layout: 'noBordersNoPadding',

                    table: chartInformation
                },
                filterView
            ]
        };
    },

    headerPortrait: function( chartInformation ){
        return {
            layout: 'noBordersNoPadding',

            table: chartInformation
        };
    },

    singleImage: function( image, margins ){
        return {
            layout: 'noBordersNoPadding',
            marginTop: margins.top,
            table: {
                width: ['100%'],
                body: [
                    [
                        image
                    ]
                ]
            }
        };
    },

    pageBreaker : function() {
        return {
            pageBreak: 'after',
            text: ''
        }
    },

    horizontalDoubleImages: function(imageLeft, imageRight, marginsImage){
        return {
            columns: [
                {
                    layout: 'noBordersNoPadding',
                    width: '49%',
                    marginTop: marginsImage.top,
                    table: {
                        width: ['100%'],
                        body: [
                            [
                                imageLeft
                            ]
                        ]
                    }
                },
                {
                    width: '2%',
                    text: ''
                },
                {
                    layout: 'noBordersNoPadding',
                    marginTop: marginsImage.top,
                    table: {
                        width: ['100%'],
                        body: [
                            [
                                imageRight
                            ]
                        ]
                    }
                }
            ]
        };
    },

    simpleTable: function(dataRows, margins, tableStyle) {
        const widths = []
        for (let i = 0; i < dataRows[0].length; i++) {
            widths.push(dataRows[0][i].width)
        }
        return {
            style: tableStyle,
            layout: 'noBordersNoPadding',
            marginTop: margins.top,
            marginRight: margins.right,

            table: {
                dontBreakRows: true,
                widths: widths,
                body: dataRows
            }
        }
    },

    stackedChartTable: function(dataRows, margins, tableStyle) {
        const widths = []
        for (let i = 0; i < dataRows[0].length; i++) {
            widths.push(dataRows[0][i].width)
        }
        return {
            style: tableStyle,
            layout: 'headerBorderNoPadding',
            marginTop: 0,

            table: {
                dontBreakRows: true,
                widths: widths,
                body: dataRows
            }
        }
    }
};

export const ChartPDFOptions = {
    tableLayouts : {
        noBordersNoPadding : {
            hLineWidth: function(i, node) { return 0; },
            vLineWidth: function(i, node) { return 0; },
            paddingLeft: function(i, node) { return 0; },
            paddingRight: function(i, node) { return 0; },
            paddingTop: function(i, node) { return 0; },
            paddingBottom: function(i, node) { return 0; }
        },
        simpleBorders : {
            hLineWidth: function(i, node) { return 1; },
            vLineWidth: function(i, node) { return 1; },
            paddingLeft: function(i, node) { return 0; },
            paddingRight: function(i, node) { return 0; },
            paddingTop: function(i, node) { return 0; },
            paddingBottom: function(i, node) { return 0; }
        },
        thinBordersNoPaddingsForFilterView: {
            hLineWidth: function (i, node) { return 0.4; },
            vLineWidth: function (i, node) { return 0.4; },
            paddingLeft: function (i, node) { return 0; },
            paddingRight: function (i, node) { return 0; },
            paddingTop: function (i, node) { return 0; },
            paddingBottom: function (i, node) { return 0; },
            hLineColor: function (i, node) { return '#EFEFEF' },
            vLineColor: function (i, node) { return '#EFEFEF' }
        },
        headerBorderSeparatedRows: {
            hLineWidth: function(i, node) { return 0.4; },
            vLineWidth: function(i, node) { return 0; },
            paddingLeft: function(i, node) { return 5; },
            paddingRight: function(i, node) { return 5; },
            paddingTop: function(i, node) { return 5; },
            paddingBottom: function(i, node) { return 5; },
            hLineColor: function(i, node) {
                return (i === 0 || i === node.table.body.length) ? '#fbfbfb' : '#f0f0f0';
            },
            vLineColor: function(i, node) {
                return (i === 0 || i === node.table.widths.length) ? 'red' : 'blue';
            }
        },
        headerBorderNoPadding: {
            hLineWidth: function (i, node) {
                return (i === 1) ? 2 : 0;
            },
            vLineWidth: () => 0,
            hLineColor: () => '#eeeeee',
            paddingLeft: () => 0,
            paddingRight: () => 0,
            paddingTop: () => 0,
            paddingBottom: () => 0,
        }
    }
};


export const ChartPDFStyles = {
    headerSeparator: {
        marginTop: 6,
        marginBottom: 8
    },
    chartNameLabel: {
        fontSize: 12,
        bold: true
    },
    dateRangeLabel: {
        marginTop: 5,
        fontSize: 12
    },
    grandTotalLabel: {
        fontSize: 9
    },
    grandValue: {
        bold: true
    },
    grandPostfix: {
        bold: true
    },

    filterView: {
        fillColor: '#EFEFEF',
        color: '#373737'
    },
    dataTable: {
        fontSize: 7,
        color: '#111111'
    },

    dataTableSmall: {
        fontSize: 5.4,
        color: '#111111'
    },
    secondDataRow: {
        fillColor: '#EFEFEF'
    },
    dataName: {
        alignment: 'left',
        margin: [10, 2, 0, 2]
    },
    dataNameSmall: {
        alignment: 'left',
        margin: [10, 0, 0, 0]
    },
    dataValue: {
        alignment: 'right',
        margin: [5, 2, 5, 2]
    },
    dataValueSmall: {
        alignment: 'right',
        margin: [5, 0, 5, 0]
    },
    dataValueWithPercents: {
        alignment: 'right',
        margin: [2, 2, 0, 2]
    },
    dataValueWithPercentsSmall: {
        alignment: 'right',
        margin: [2, 0, 0, 0]
    },
    footerTable: {
        margin: [23, 0, 23, 0],
        fontSize: 7
    },

    rightFooterPart: {
        alignment: 'right',
        color: '#3D3D3D'
    },
    leftFooterPart: {
        alignment: 'left',
        color: '#6A6A6A'
    }
}

export const ChartPDFFooters = {
    simpleFooter : function() {

        return function(currentPage, pageCount) {

            return {
                style: 'footerTable',
                layout: 'noBordersNoPadding',

                table: {
                    widths: ['90%','10%'],
                    body: [
                        [
                            {
                                style: 'leftFooterPart',
                                text: messageResource.getMessage('report.chart_pdf.leftFooterLabel', [new DateFormat( window.SystemSettings.dateFormat ).formatDate( new Date() )])
                            },
                            {
                                style: 'rightFooterPart',
                                text: messageResource.getMessage('report.chart_pdf.rightFooterLabel', [currentPage, pageCount])
                            }
                        ]
                    ]
                }
            }
        };
    }
};

/**
 * utils method needed to return sizes of images depends on parameters
 * @param paperOrientation - page orientation
 * @param paperSize - papers size
 * @param chartType - current chartType
 * @param isDoubleImagesOnPage - singleOrDoubleImages on page (double if no need to show data list)
 * @returns {*}
 */
export const getNeededImageDimensions = function(paperOrientation, paperSize, chartType, isDoubleImagesOnPage){
    var dimensions = {};
    $.extend(true, dimensions, _getChartDependentsParameters(paperOrientation, paperSize, chartType).imageParams);
    if (isDoubleImagesOnPage){
        return dimensions.doubleImage.sizes;
    } else {
        return dimensions.singleImage.sizes;
    }
};

const _getChartDependentsParameters = function(paperOrientation, paperSize, chartType){
    const paramsForReturn = {};
    const chartTypeParams = ChartPDFParameters[paperOrientation][paperSize][chartType]
    $.extend(paramsForReturn, chartTypeParams);
    return paramsForReturn;
}

export const getMaxValuesOnPageProperty = function({paperOrientation, paperSize, chartType}) {
    return _getChartDependentsParameters(paperOrientation, paperSize, chartType).maxValuesOnPage
}

export const getMaxValuesOnFitPageProperty = function({paperOrientation, paperSize, chartType}) {
    return _getChartDependentsParameters(paperOrientation, paperSize, chartType).maxValuesOnFitPage
}

export const getMaxValuesOnPageWithoutImageProperty = function({paperOrientation, paperSize, chartType, withHeader}) {
    if (withHeader) {
        return _getChartDependentsParameters(paperOrientation, paperSize, chartType).maxValuesOnPageWithoutImage.withHeader
    }
    return _getChartDependentsParameters(paperOrientation, paperSize, chartType).maxValuesOnPageWithoutImage.withoutHeader
}

export const getMaxValuesOnFitPageWithoutImageProperty = function({paperOrientation, paperSize, chartType, withHeader}) {
    if (withHeader) {
        return _getChartDependentsParameters(paperOrientation, paperSize, chartType).maxValuesOnFitPageWithoutImage.withHeader
    }
    return _getChartDependentsParameters(paperOrientation, paperSize, chartType).maxValuesOnFitPageWithoutImage.withoutHeader
}

export const ChartPDFParameters = {

    dataTableCommonStyles : {
        small : {
            tableStyle : 'dataTableSmall',
            tableValueStyles : {
                dataValueStyle : 'dataValueSmall',
                dataValueWithPercentStyle : 'dataValueWithPercentsSmall',
                dataNameStyle : 'dataNameSmall',
                colorRectangleDimensions: {
                    paddingLeft: 16,
                    x: 4,
                    y: 1.25,
                    h: 3.8,
                    w: 7
                }
            }
        },
        big : {
            tableStyle : 'dataTable',
            tableValueStyles : {
                dataValueStyle : 'dataValue',
                dataValueWithPercentStyle : 'dataValueWithPercents',
                dataNameStyle : 'dataName',
                colorRectangleDimensions: {
                    paddingLeft: 18,
                    x: 4,
                    y: 4,
                    h: 5,
                    w: 9
                }
            }
        },
    },

    logoPlaceholderSizes : {
        width: 100,
        height: 56
    },

    [PaperOrientation.LANDSCAPE] : {
        pageOrientation : 'landscape',
        pageMargins: [56, 28, 56, 28],

        filterViewParameters: {
            margins: {
                top: 0
            },
            imageWidth: 10,
            fontSize: 9,
            widths: ['12%', '88%'],
        },

        filterViewParametersWithTwoRows: {
            imageMargins: {
                top: 11,
                left: 12
            },
            firstRowMargins: {
                top: 10,
                bottom: 5,
            },
            secondRowMargins: {
                top: 8,
                bottom: 9,
            },
        },

        filterViewParametersWithThreeRows: {
            imageMargins: {
                top: 8,
                left: 12
            },
            firstRowMargins: {
                top: 7,
                bottom: 0,
            },
            secondRowMargins: {
                top: 3,
                bottom: 0,
            },
            thirdRowMargins: {
                top: 4,
                bottom: 7,
            }
        },

        [PaperSize.A4] : {
            pageSize: 'A4',

            filterViewTextLen: 51,//57

            chartInfoParameters : {
                withLogo : {
                    splitterLen: 350,
                    widths : ['25%', '75%']
                },
                withoutLogo : {
                    splitterLen: 460,
                    widths : ['0%','100%']
                }
            },

            [ChartType.VERTICAL_BAR]: {
                maxValuesOnPage: 21,
                maxValuesOnFitPage : 42,

                rowDataMaxLen: {
                    normal : {
                        valueAndPercents : 120,
                        valueOrPercents : 126
                    },
                    fit : {
                        valueAndPercents : 160,
                        valueOrPercents: 165
                    }
                },
                dataTableMargins : {
                    top: 10,
                    right: 200,
                },
                imageParams: {
                    singleImage : {
                        margins : {
                            top: 20
                        },
                        sizes : {
                            h : 180,
                            w : 725
                        }
                    },
                    doubleImage : {
                        margins : {
                            top: 20
                        },
                        sizes :{
                            h : 180,
                            w : 725
                        }
                    }
                }
            },
            [ChartType.HORIZONTAL_BAR]: {
                maxValuesOnPage: -1, // not used
                maxValuesOnFitPage: -1, // not used

                maxValuesOnPageWithoutImage: {
                    withHeader: 36,
                    withoutHeader: 42
                },

                maxValuesOnFitPageWithoutImage: {
                    withHeader: 72,
                    withoutHeader: 82,
                },

                rowDataMaxLen: {
                    normal : {
                        valueAndPercents : 120,
                        valueOrPercents : 126
                    },
                    fit : {
                        valueAndPercents : 160,
                        valueOrPercents: 165
                    }
                },
                dataTableMargins : {
                    top: 0,
                    right: 200,
                },
                imageParams: {
                    singleImage : {
                        margins : {
                            top: 15
                        },
                        sizes : {
                            h : 460,
                            w : 735
                        }
                    },
                    doubleImage : {
                        margins : {
                            top: 15
                        },
                        sizes : {
                            h : 460,
                            w : 354
                        }
                    }
                }
            },
            [ChartType.PIE_CHART] : {} // no need fo this chart type
        },

        [PaperSize.LETTER] : {
            pageSize: 'Letter',

            filterViewTextLen: 48,//54

            chartInfoParameters : {
                withLogo : {
                    splitterLen: 315,
                    widths : ['25%', '75%']
                },
                withoutLogo : {
                    splitterLen: 430,
                    widths : ['0%','100%']
                }
            },

            [ChartType.VERTICAL_BAR]: {
                maxValuesOnPage: 22,
                maxValuesOnFitPage: 44,

                rowDataMaxLen: {
                    normal : {
                        valueAndPercents : 125,
                        valueOrPercents : 135
                    },
                    fit : {
                        valueAndPercents : 165,
                        valueOrPercents: 170
                    }
                },
                dataTableMargins : {
                    top: 10,
                    right: 140,
                },
                imageParams: {
                    singleImage : {
                        margins : {
                            top: 20
                        },
                        sizes : {
                            h : 180,
                            w : 675
                        }
                    },
                    doubleImage : {
                        margins : {
                            top: 20
                        },
                        sizes : {
                            h : 180,
                            w : 675
                        }
                    }
                }
            },
            [ChartType.HORIZONTAL_BAR]: {
                maxValuesOnPage: -1, // not used
                maxValuesOnFitPage: -1, // not used

                maxValuesOnPageWithoutImage: {
                    withHeader: 38,
                    withoutHeader: 44
                },

                maxValuesOnFitPageWithoutImage: {
                    withHeader: 76,
                    withoutHeader: 86,
                },

                rowDataMaxLen: {
                    normal : {
                        valueAndPercents : 125,
                        valueOrPercents : 135
                    },
                    fit : {
                        valueAndPercents : 165,
                        valueOrPercents: 170
                    }
                },
                dataTableMargins : {
                    top: 15,
                    right: 140,
                },
                imageParams: {

                    singleImage : {
                        margins : {
                            top: 15
                        },
                        sizes : {
                            h : 465,
                            w : 690
                        }
                    },
                    doubleImage : {
                        margins : {
                            top: 15
                        },
                        sizes : {
                            h : 465,
                            w : 330
                        }
                    }
                }
            },
            [ChartType.PIE_CHART] : {} // no need fo this chart type
        }
    },
    [PaperOrientation.PORTRAIT] : {
        pageOrientation : 'portrait',
        pageMargins: [ 40, 28, 40, 28 ],

        filterViewParameters: {
            margins: {
                top: 12
            },
            widths: ['6%', '94%'],
            imageWidth: 10,
            fontSize: 9
        },

        filterViewParametersWithTwoRows: {
            imageMargins: {
                top: 11,
                left: 12
            },
            firstRowMargins: {
                top: 10,
                bottom: 5,
            },
            secondRowMargins: {
                top: 8,
                bottom: 9,
            },
        },

        filterViewParametersWithThreeRows: {
            imageMargins: {
                top: 6,
                left: 12
            },
            firstRowMargins: {
                top: 5,
                bottom: 0
            },
            secondRowMargins: {
                top: 3,
                bottom: 0,
            },
            thirdRowMargins: {
                top: 3,
                bottom: 5,
            },
        },

        [PaperSize.A4] : {
            pageSize: 'A4',

            filterViewTextLen: 102, //108

            chartInfoParameters : {
                withLogo : {
                    splitterLen: 403,
                    widths : ['22%', '78%']
                },
                withoutLogo : {
                    splitterLen: 517,
                    widths : ['0%','100%']
                }
            },

            [ChartType.VERTICAL_BAR]: {
                maxValuesOnPage: 28,
                maxValuesOnFitPage: 56,

                rowDataMaxLen: {
                    normal : {
                        valueAndPercents : 120,
                        valueOrPercents : 126
                    },
                    fit : {
                        valueAndPercents : 160,
                        valueOrPercents: 165
                    }
                },
                dataTableMargins : {
                    top: 18
                },
                imageParams: {
                    singleImage : {
                        margins : {
                            top: 15
                        },
                        sizes : {
                            h : 260,
                            w : 513
                        }
                    },
                    doubleImage : {
                        margins : {
                            top: 15
                        },
                        sizes : {
                            h : 260,
                            w : 513
                        }
                    }
                }
            },
            [ChartType.HORIZONTAL_BAR]: {
                maxValuesOnPage: 24,
                maxValuesOnFitPage: 48,

                rowDataMaxLen: {
                    normal : {
                        valueAndPercents : 120,
                        valueOrPercents : 126
                    },
                    fit : {
                        valueAndPercents : 160,
                        valueOrPercents: 165
                    }
                },
                dataTableMargins : {
                    top: 18
                },
                imageParams: {
                    singleImage : {
                        margins : {
                            top: 15
                        },
                        sizes : {
                            h : 330,
                            w : 513
                        }
                    },
                    doubleImage : {
                        margins : {
                            top: 20
                        },
                        sizes : {
                            h : 290,
                            w : 513
                        }
                    }
                }
            },
            [ChartType.PIE_CHART] : {
                maxValuesOnPage: 26,
                maxValuesOnFitPage: 52,

                maxValuesOnPageWithoutImage: {
                    withHeader: 52,
                    withoutHeader: 62
                },

                rowDataMaxLen: {
                    normal : {
                        valueAndPercents : 115,
                        valueOrPercents : 120
                    },
                    fit : {
                        valueAndPercents : 155,
                        valueOrPercents: 160
                    }
                },
                dataTableMargins : {
                    top: 8
                },
                imageParams: {
                    singleImage : {
                        margins : {
                            top: 25
                        },
                        sizes : {
                            h : 305,
                            w : 513
                        }
                    },
                    doubleImage : {} //no need fot this chart type
                }
            }
        },
        [PaperSize.LETTER] : {
            pageSize: 'Letter',

            filterViewTextLen: 105,// 111

            chartInfoParameters : {
                withLogo : {
                    splitterLen: 415,
                    widths : ['22%', '78%']
                },
                withoutLogo : {
                    splitterLen: 533,
                    widths : ['0%','100%']
                }
            },

            [ChartType.VERTICAL_BAR]: {
                maxValuesOnPage: 24,
                maxValuesOnFitPage: 48,

                rowDataMaxLen: {
                    normal : {
                        valueAndPercents : 125,
                        valueOrPercents : 135
                    },
                    fit : {
                        valueAndPercents : 165,
                        valueOrPercents: 170
                    }
                },
                dataTableMargins : {
                    top: 18
                },
                imageParams: {
                    singleImage : {
                        margins : {
                            top: 15
                        },
                        sizes : {
                            h : 260,
                            w : 530
                        }
                    },
                    doubleImage : {
                        margins : {
                            top: 15
                        },
                        sizes : {
                            h : 260,
                            w : 530
                        }
                    }
                }
            },
            [ChartType.HORIZONTAL_BAR]: {
                maxValuesOnPage: 20,
                maxValuesOnFitPage: 40,

                rowDataMaxLen: {
                    normal : {
                        valueAndPercents : 125,
                        valueOrPercents : 135
                    },
                    fit : {
                        valueAndPercents : 165,
                        valueOrPercents: 170
                    }
                },
                dataTableMargins : {
                    top: 18
                },
                imageParams: {
                    singleImage : {
                        margins : {
                            top: 15
                        },
                        sizes : {
                            h : 330,
                            w : 530
                        }
                    },
                    doubleImage : {
                        margins : {
                            top: 15
                        },
                        sizes : {
                            h : 280,
                            w : 530
                        }
                    }
                }
            },
            [ChartType.PIE_CHART] : {
                maxValuesOnPage: 22,
                maxValuesOnFitPage: 44,

                maxValuesOnPageWithoutImage: {
                    withHeader: 49,
                    withoutHeader: 58

                },

                rowDataMaxLen: {
                    normal : {
                        valueAndPercents : 120,
                        valueOrPercents : 130
                    },
                    fit: {
                        valueAndPercents: 160,
                        valueOrPercents: 165
                    }
                },
                dataTableMargins : {
                    top: 8
                },
                imageParams: {
                    singleImage : {
                        margins : {
                            top: 25
                        },
                        sizes : {
                            h : 305,
                            w : 530
                        }
                    },
                    doubleImage : {} //no need fot this chart type
                }
            }
        }
    }
};



// WEBPACK FOOTER //
// ./web/js/reports/charts/pdfgenerator/ChartPDFDefinitionPartsConstructors.js